import { useFormContext } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import CategoryField from './CategoryField'
import SubcategoryField from './SubcategoryField'

interface Props extends PermissionsProps, CustomizationProps {}

const Category = (props: Props) => {
  const { watch } = useFormContext()
  const { resourceType } = props
  const category = watch('category')

  const isExpense = resourceType === 'expense'
  return (
    <Box gap="s16">
      {/* TODO Maybe handle in schema with the showBlock pattern */}
      {isExpense && <CategoryField {...props} fieldIdentifier="category" />}
      <SubcategoryField {...props} fieldIdentifier="subcategory" category={category} />
    </Box>
  )
}

export default Category
